
import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'picture-input-type',
  templateUrl: './picture-input-type.component.html',
  styleUrls: ['./picture-input-type.component.css']
})

export class PictureInputTypeComponent {

  //self explanatory

  @Input() question_index: number;
  @Input() question_name : string;
  @Input() question_name_second : string;
  @Input() is_mandt : boolean;
  @Input() indexOfRepeater : number;
  @Input() question_number : number;
  @Input() userRes : string[];
  @Output() user_Resp = new EventEmitter<string[]>();
  

  image_url : string = "../../../assets/images/default_profile_pic.jpg";
  isUploadPic :boolean = false;
  response:string ;

  clicked($event){
    var files = $event.srcElement.files;

    var reader = new FileReader();
    // read the image file as a data URL.
    reader.readAsDataURL(files[0]);

    reader.onload =  (e) => {
        // get loaded data and render thumbnail.
        this.image_url = e.target['result'];
        this.response = this.image_url.replace(/^data:image\/[a-z]+;base64,/, "");
        this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),this.response]);
    };
  }

  inputPicture(){
    this.isUploadPic  = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/questions-type/picture-input-type/picture-input-type.component.ts